import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE } from 'src/constants/pagination';
import wrapper from 'src/redux';
import {
	actionGetArticleByCategorySlug,
	actionGetFooterMenu,
	actionGetMenu,
	actionGetSubCategoryByParentCategorySlug,
} from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const SubCategoryMenu = dynamic(() => import('src/containers/Category/SubCategoryMenu'));

const ParentCategoryPage = () => {
	return (
		<>
			<HeadC
				title="Informasi Psikologi Terlengkap"
				description={
					'Informasi psikologi terlengkap dan tepercaya, membahas topik kesehatan mental, ' +
					'hubungan keluarga, hingga asmara hanya di KlikDokter.'
				}
			/>
			<div className="container">
				<SubCategoryMenu adSource="psikologi" adTarget={[['channel', ['psikologi']]]} />
			</div>
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const slug = 'psikologi';

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	await store.dispatch(
		actionGetArticleByCategorySlug(slug, {
			should_show_headline: true,
			page: DEFAULT_PAGE_INDEX,
			per_page: DEFAULT_PER_PAGE,
		}),
	);
	await store.dispatch(
		actionGetSubCategoryByParentCategorySlug(slug, {
			page: DEFAULT_PAGE_INDEX,
			per_page: 5,
			orderby: 'name',
			order: 'asc',
		}),
	);

	return {
		props: {
			card: true,
			isWhiteBackground: true,
			pageHeaderContent: {
				title: 'Psikologi',
				breadcrumbs: [{ label: 'Psikologi' }],
			},
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default ParentCategoryPage;
